<template>
  <div class="categories-list">
    <CategoryItem
        v-for="category in categories"
        :key="(category as any).code"
        :category="category"
        @update="selectCategory"
    />
  </div>
</template>

<script setup lang="ts">
import {useSearchStore} from "~/store/search";
import { useRoute } from "vue-router";
import CategoryItem from "~/components/MarketPage/Filters/CategoryItem.vue";

const searchStore = useSearchStore();
const route = useRoute();
//define emits

const emit = defineEmits(['update']);
//define props

const categories = computed(() => {
  return searchStore.activityCategories || []
})

const selectedCategories = ref([] as string[])


function selectCategory(childSelected: string[]) {
  // CategoryItem emits its full selected subcategory codes array.
  // Replace parent state with what the child reports (checkboxes handle toggling internally).
  selectedCategories.value = childSelected
  emit('update', [...selectedCategories.value]);
}

onMounted(() => {
  selectedCategories.value = (route?.query?.categories as string)?.split(',') || [];
})

watch(
  () => route.query.categories,
  (value) => {
    if (!value) {
      selectedCategories.value = [];
      return;
    }

    if (Array.isArray(value)) {
      selectedCategories.value = value.filter(Boolean) as string[];
      return;
    }

    selectedCategories.value = (value as string).split(',').filter(Boolean);
  }
);


</script>

<style lang="scss">
.categories-list {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .category-item {
    &--head {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    &--title {
      display: flex;
      gap: 8px;
      align-items: center;
      line-height: 1
    }

    &--toggle-btn {
      cursor: pointer;
    }

    &--count {
      color: var(--dark-grey-secondary);
      font-size: 14px;
    }
  }

  .categories-list-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .subcategories-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 28px;
    padding: 8px 0;

    .category-item {
      display: flex;
      gap: 8px;
    }
  }
}
</style>
